<div #parentContainer>
  <div
    #contentSlot
    (click)="!disable ? (bottomSheet ? openBottomSheet() : itemsMenuTrigger.openMenu()) : undefined"
  >
    <ng-content></ng-content>
  </div>
  @if (!contentSlot.children.length) {
    <div
      class="w-max flex items-center px-base py-sm border border-ui-separator rounded-sm {{
        extraClass
      }}"
      [ngClass]="{ 'cursor-pointer': !disable, '!w-full': fullWidth }"
      (click)="!disable ? (bottomSheet ? openBottomSheet() : itemsMenuTrigger.openMenu()) : undefined"
    >
      <div class="flex-1 text-txt text-base leading-base {{ extraLabelClass }}">
        {{
          selectedItemLabel
            ? selectedItemPrefix
              ? selectedItemPrefix + ' ' + selectedItemLabel
              : selectedItemLabel
            : placeHolder
        }}
      </div>
      @if (!disable && (!clearable || !selectedItem)) {
        <div class="ml-sm flex text-txt-secondary">
          <svg-icon [key]="icon" class="!text-xs"></svg-icon>
        </div>
      }
      @if (clearable && selectedItem) {
        <div class="ml-sm flex text-txt-secondary" (click)="clearSelectedItem($event)">
          <svg-icon key="close-circle" class="!text-sm"></svg-icon>
        </div>
      }
    </div>
  }
  <div
    [matMenuTriggerFor]="itemsMenu"
    #itemsMenuTrigger="matMenuTrigger"
    (menuOpened)="onMenuOpened()"
  ></div>
</div>

<mat-menu #itemsMenu="matMenu" [hasBackdrop]="true" class="mg-filter-menu" [xPosition]="xPosition">
  <div
    class="p-xs flex flex-col overflow-auto w-full min-w-max"
    [style.width.px]="menuWidth"
    (click)="$event.stopPropagation()"
  >
    @for (item of items; track item.value) {
      <div
        class="p-xs cursor-pointer hover:bg-ui-hover text-txt text-base leading-base {{
          extraItemClass
        }}"
        [ngClass]="{ '!bg-ui-hover-1': item.value === selectedItem }"
        (click)="selectedItemChanged.emit(item.value); itemsMenuTrigger.closeMenu()"
      >
        {{ item.label }}
      </div>
    }
  </div>
</mat-menu>
